import React, { useEffect, useState } from 'react';
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer';
import { api } from '../../services/api';
import Swal from 'sweetalert2';
import { FaBullhorn, FaPaperPlane, FaArrowLeft } from 'react-icons/fa';
import './ouvidoria.css';

const Ouvidoria = () => {
    const chapaLocal = localStorage.getItem('chapa');
    const chapa = localStorage.getItem('chapa');
    const lojaLocal = localStorage.getItem('loja');

    const [tipos, setTipos] = useState([]);
    const [setores, setSetores] = useState([]);
    const [pontuacoes, setPontuacoes] = useState([]);

    const [tipoSelecionado, setTipoSelecionado] = useState('');
    const [setorSelecionado, setSetorSelecionado] = useState('');
    const [pontoSelecionado, setPontoSelecionado] = useState('');
    const [mensagem, setMensagem] = useState('');
    const [identificado, setIdentificado] = useState(true);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const carregarDados = async () => {
            try {
                const res = await api.get('/usuario/ouvidoria/listar');
                setTipos(res.data.tipo.map(t => t.valor2));
                setSetores(res.data.setor.map(s => s.valor2));
                setPontuacoes(res.data.ponto.map(p => p.valor2));
            } catch (err) {
                Swal.fire('Erro', 'Não foi possível carregar os dados.', 'error');
            }
        };
        carregarDados();
    }, []);

    const progresso = () => {
        let total = 4;
        let preenchidos = 0;
        if (tipoSelecionado) preenchidos++;
        if (setorSelecionado) preenchidos++;
        if (pontoSelecionado) preenchidos++;
        if (mensagem) preenchidos++;
        return (preenchidos / total) * 100;
    };

    const enviarOuvidoria = async () => {
        if (!tipoSelecionado || !setorSelecionado || !pontoSelecionado || !mensagem) {
            Swal.fire('Atenção', 'Preencha todos os campos obrigatórios.', 'warning');
            return;
        }

        const payload = {
            chapa: identificado ? chapaLocal : '',
            tipo: tipoSelecionado,
            loja: lojaLocal,
            setor: setorSelecionado,
            ponto: pontoSelecionado,
            usuario: chapa,
            mensagem
        };

        try {
            setLoading(true);
            await api.post('/usuario/ouvidoria', payload);

            Swal.fire('Enviado', 'Ouvidoria registrada com sucesso.', 'success');

            setTipoSelecionado('');
            setSetorSelecionado('');
            setPontoSelecionado('');
            setMensagem('');
        } catch (err) {
            Swal.fire('Erro', 'Erro ao registrar a ouvidoria.', 'error');
        } finally {
            setLoading(false);
        }
    };

    const RadioButtonGroup = ({ lista, selecionado, setSelecionado, name }) => (
        <div className="radio-grid">
            {lista.map((item, idx) => (
                <label
                    key={idx}
                    className={`radio-card ${selecionado === item ? 'active' : ''}`}
                >
                    <input
                        type="radio"
                        name={name}
                        value={item}
                        checked={selecionado === item}
                        onChange={() => setSelecionado(item)}
                    />
                    <span>{item}</span>
                </label>
            ))}
        </div>
    );

    return (
        <div className="ouvidoria-page">
            <Menu modulo="ARBOR" />

            <div className="ouvidoria-wrapper">
                <div className="ouvidoria-container">

                    {/* HEADER */}
                    <div className="ouvidoria-header shadow-sm">
                        <FaBullhorn size={26} />
                        <div>
                            <h3 className="mb-0 text-white fw-bold">Ouvidoria</h3>
                            <small className="ouvidoria-subtitle">
                                Canal seguro e confidencial. Sua manifestação é enviada diretamente à Presidência,
                                garantindo total sigilo e independência no tratamento das informações.
                            </small>
                        </div>
                    </div>

                    {/* PROGRESSO */}
                    <div className="progress mt-3 style-progress">
                        <div
                            className="progress-bar bg-danger"
                            style={{ width: `${progresso()}%` }}
                        />
                    </div>

                    {/* CARD PRINCIPAL */}
                    <div className="ouvidoria-card mt-3">
                        {/* Tipo */}
                        <h6 className="section-title">Tipo da ouvidoria</h6>
                        <RadioButtonGroup
                            lista={tipos}
                            selecionado={tipoSelecionado}
                            setSelecionado={setTipoSelecionado}
                            name="tipo"
                        />

                        {/* Setor */}
                        <h6 className="section-title mt-4">Quero falar sobre</h6>
                        <RadioButtonGroup
                            lista={setores}
                            selecionado={setorSelecionado}
                            setSelecionado={setSetorSelecionado}
                            name="setor"
                        />

                        {/* Pontuação */}
                        <h6 className="section-title mt-4">Pontuação</h6>
                        <RadioButtonGroup
                            lista={pontuacoes}
                            selecionado={pontoSelecionado}
                            setSelecionado={setPontoSelecionado}
                            name="ponto"
                        />

                        {/* Mensagem */}
                        <h6 className="section-title mt-4">Mensagem</h6>
                        <textarea
                            className="form-control mensagem-box"
                            rows={4}
                            maxLength={500}
                            value={mensagem}
                            onChange={(e) => setMensagem(e.target.value)}
                            placeholder="Digite sua mensagem..."
                        />
                        <div className="text-end small text-muted mt-1">
                            {mensagem.length}/500
                        </div>

                        {/* Identificação */}
                        <div className="form-check form-switch mt-3">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={identificado}
                                onChange={() => setIdentificado(!identificado)}
                            />
                            <label className="form-check-label fw-bold">
                                Me identificar
                            </label>
                        </div>

                        {/* BOTÕES */}
                        <div className="ouvidoria-actions mt-4">
                            <button
                                className="btn btn-light px-4"
                                onClick={() => window.history.back()}
                            >
                                <FaArrowLeft className="me-2" />
                                Cancelar
                            </button>

                            <button
                                className="btn btn-enviar-ouvidoria px-4"
                                onClick={enviarOuvidoria}
                                disabled={loading}
                            >
                                {loading ? (
                                    'Enviando...'
                                ) : (
                                    <>
                                        <FaPaperPlane className="me-2" />
                                        Enviar
                                    </>
                                )}
                            </button>
                        </div>
                    </div>

                </div>
            </div>

            <Footer />
        </div>
    );
};

export default Ouvidoria;